import ComponentFadeIn from '../functionality/componentFadeIn';
import {CustomWebAppsIcon,UIModernizationIcon,PerformanceScalingIcon,PerformanceOptimizationIcon,BackendAPIIcon,CloudDeploymentIcon} from './icons/icons'
import './card.css';

const services = [
  {
    icon: CustomWebAppsIcon,
    title: "Custom Web Applications",
    desc: "Modern, tailored web applications built around your business workflows."
  },
  {
    icon: BackendAPIIcon,
    title: "Backend & API Development",
    desc: "Scalable, maintainable APIs designed for performance and long-term growth."
  },
  {
    icon: UIModernizationIcon,
    title: "UI Modernization",
    desc: "Transform outdated systems into fast, intuitive, modern experiences."
  },
  {
    icon: PerformanceScalingIcon,
    title: "Performance & Scaling",
    desc: "Architect solutions that scale efficiently and stay reliable under load."
  },
  {
    icon: CloudDeploymentIcon,
    title: "Cloud & Deployment Architecture",
    desc: "Design and implement cloud-based infrastructure with CI/CD pipelines, containerization, and secure deployment strategies."
  },
  {
    icon: PerformanceOptimizationIcon,
    title: "Performance Optimization",
    desc: "Analyze and optimize application performance, database queries, and infrastructure to ensure systems scale efficiently under real-world load."
  }
];
export default function Services() {
  return (
    <section className="services">
      {services.map((service, index) => {
        const IconComponent = service.icon; // ✅ grab the icon component

        return (
          <ComponentFadeIn
            key={index}
            delay={index * 150}
            direction={index % 2 === 0 ? "left" : "right"}
          >
            <div className="service-card">
              <div className="icon" style={{ marginBottom: "12px" }}>
                <IconComponent width={64} height={64} /> {/* render the icon */}
              </div>
              <div className="service-text">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            </div>
          </ComponentFadeIn>
        );
      })}
    </section>
  );
}